import { css } from '@inter-ikea-kompis/web-component';
export default class DurabilityIndexStyle {
    static getStyle() {
        return css `
			:host {
				/* Set to match the size of the text in the image to the font-size of the primary price. */
				font-size: 2.1em;
				display: block;
			}
		`;
    }
}
//# sourceMappingURL=DurabilityIndexStyle.js.map